<table mat-table [dataSource]="dataSource" id="components-table" matSort [matSortActive]="getActiveSortColumn()" [matSortDirection]="getActiveSortDirection()" (matSortChange)="onSortChanged($event)">

  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('id') }" type="button">
          {{ 'commonPackagingFields.id' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('id'))">filter_alt</mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.id}} </td>
  </ng-container>

  <ng-container matColumnDef="tracking">
    <th mat-header-cell *matHeaderCellDef [hidden]="!displayTrackedColumn"></th>
    <td mat-cell *matCellDef="let element" [hidden]="!displayTrackedColumn">
      <mat-icon *ngIf="element.hasExternalTracking">track_changes</mat-icon>
    </td>
  </ng-container>

  <ng-container matColumnDef="tags">
    <th mat-header-cell *matHeaderCellDef>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.tagFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('tags'), possibleTags: getPossibleTags() }"
          type="button">
          {{ 'dataManagement.tags.titleTags' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('tags'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <app-tag-directive [tags]="getTagsFromIds(element.associatedTagIdentifiers)" [maxDisplayed]="2">
      </app-tag-directive>
    </td>
  </ng-container>

  <ng-container matColumnDef="packagingComponentCategoryName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('packagingComponentCategoryName'), categories: getComponentCategoryNames() }"
          type="button">
          {{ 'component.componentType' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingComponentCategoryName'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <img [src]="getComponentTypeImage(element.packagingComponentCategoryId)" class="component-type-image"
        [matTooltip]="element.packagingComponentCategoryName">
    </td>
  </ng-container>

  <ng-container matColumnDef="packagingComponentCategoryNameNoFilter">
    <th mat-header-cell *matHeaderCellDef>
      <span class="header-text">{{ 'component.componentType' | transloco }}</span>
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.packagingComponentCategoryName }} </td>
  </ng-container>

  <ng-container matColumnDef="packagingComponentSubtypeName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('packagingComponentSubtypeName'), categories: getSpecificComponentTypeNames() }"
          type="button">
          {{ 'component.componentSpecificType' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('packagingComponentSubtypeName'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{ element.packagingComponentSubtypeName }} </td>
  </ng-container>

  <ng-container matColumnDef="articleName">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('articleName') }" type="button">
          {{ 'component.fields.articleName' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleName'))">filter_alt</mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.articleName}} </td>
  </ng-container>

  <ng-container matColumnDef="articleNumber">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('articleNumber') }" type="button">
          {{ 'component.fields.articleNumber' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('articleNumber'))">filter_alt</mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.articleNumber}} </td>
  </ng-container>

  <ng-container matColumnDef="creationTimestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.dateFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('creationTimestamp') }" type="button">
          {{ 'commonPackagingFields.creationDate' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('creationTimestamp'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      {{formatDateToString(element.creationTimestamp)}}
    </td>
  </ng-container>

  <ng-container matColumnDef="lastModificationTimestamp">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.dateFilterMenu"
          [matMenuTriggerData]="{ caller: getCaller('lastModificationTimestamp') }" type="button">
          {{ 'commonPackagingFields.lastModificationDate' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('lastModificationTimestamp'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      {{formatDateToString(element.lastModificationTimestamp)}}
    </td>
  </ng-container>

  <ng-container matColumnDef="manufacturer">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" [matMenuTriggerFor]="filterComponent.filterMenu"
          [matMenuTriggerData]="{ caller: getCaller('manufacturer') }" type="button">
          {{ 'component.fields.manufacturer' | transloco }}
          <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('manufacturer'))">filter_alt
          </mat-icon>
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element"> {{element.manufacturer}} </td>
  </ng-container>

  <ng-container matColumnDef="action">
    <th mat-header-cell *matHeaderCellDef>
      <span class="header-text">{{ 'dataManagement.actions' | transloco }}</span>
    </th>
    <td mat-cell *matCellDef="let element">
      <button *ngIf="!isRecyclingBinSelected" mat-icon-button (click)="navigateToComponent(element)"
        matTooltip="{{ 'component.editComponent' | transloco }}" type="button">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button (click)="deletePackagingPart([element.id])"
        matTooltip="{{ 'component.deleteComponent' | transloco }}" type="button">
        <mat-icon>delete_forever</mat-icon>
      </button>
      <button mat-icon-button [matMenuTriggerFor]="reports.reportsMenu" (click)="reports.loadReports()"
        matTooltip="{{ 'report.tooltips.buttonTooltip' | transloco }}" *ngIf="!isRecyclingBinSelected" type="button">
        <mat-icon>topic</mat-icon>
      </button>

      <app-reports-menu-for-packaging-part #reports [callerItemId]="element.id" [callerPage]="callerPageId"
        [callerLevel]="callerLevelId">
      </app-reports-menu-for-packaging-part>
    </td>
  </ng-container>

  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <div (click)="$event.stopPropagation()">
        <button mat-button class="filter-button" (click)="selectAllComponents()" type="button">
          {{ 'common.buttons.selectAll' | transloco }} <br> ({{selectedComponentIds.length}}
          {{ 'common.text.selected' | transloco }})
        </button>
      </div>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [checked]="isItemSelected(element)" (change)="setMultipleItemsSelection($event.checked, element)">
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="single-select">
    <th mat-header-cell *matHeaderCellDef>
      <span class="header-text"> {{ 'common.buttons.select' | transloco }} </span>
    </th>
    <td mat-cell *matCellDef="let element">
      <mat-checkbox [checked]="isItemSelected(element)" (change)="setSingleItemSelection($event.checked, element)">
      </mat-checkbox>
    </td>
  </ng-container>

  <ng-container matColumnDef="subRequestStatus">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.checkboxFilterMenu"
        [matMenuTriggerData]="{ caller: getCaller('subRequestStatus'), categories: getStatusOptions() }">
        {{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes(getCaller('subRequestStatus'))">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let element">{{ getSubRequestStatusLabel(subRequestMap?.get(element.id)?.status) | transloco }}</td>
  </ng-container>

  <ng-container matColumnDef="showSubRequestComments">
    <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
    <td mat-cell *matCellDef="let element" style="width: 48px">
      <button mat-icon-button type="button" (click)="showSubRequestComments.emit(element.id); $event.stopPropagation()">
        <mat-icon
          [matBadge]="commentCountMap?.get(element.id)"
          [matBadgeHidden]="!commentCountMap?.get(element.id)"
          matBadgeColor="primary"
          matBadgeSize="small">comment</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="navigateToSubRequest">
    <th mat-header-cell *matHeaderCellDef style="width: 48px"></th>
    <td mat-cell *matCellDef="let element" style="width: 48px">
      <button [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted" mat-icon-button type="button"
        [title]="'dataManagement.dataExchangeRequests.actions.openSubRequest' | transloco"
        (click)="navigateToSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>open_in_new</mat-icon>
      </button>
    </td>
  </ng-container>

  <ng-container matColumnDef="lastModifiedAt">
    <th mat-header-cell *matHeaderCellDef mat-sort-header>
      <button mat-button class="filter-button" type="button"
        (click)="$event.stopPropagation()"
        [matMenuTriggerFor]="filterComponent.dateFilterMenu"
        [matMenuTriggerData]="{ caller: 'lastModifiedAt' }">
        {{ 'dataManagement.dataExchangeRequests.columns.lastModifiedAt' | transloco }}
        <mat-icon class="filter-icon" *ngIf="filteredColumns.includes('lastModifiedAt')">filter_alt</mat-icon>
      </button>
    </th>
    <td mat-cell *matCellDef="let row">{{ getDate(subRequestMap?.get(row.id)?.lastModifiedAt) | date:'short' }}</td>
  </ng-container>

  <ng-container matColumnDef="approveSubRequest">
    <th mat-header-cell *matHeaderCellDef style="width: 100px;text-align: center;">{{ 'dataManagement.actions' | transloco }}</th>
    <td mat-cell *matCellDef="let element" style="width: 148px">
      <button mat-icon-button type="button" [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
        [title]="'dataManagement.dataExchangeRequests.actions.approveSubRequest' | transloco"
        (click)="approveSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>check_circle</mat-icon>
      </button>
      <button mat-icon-button type="button" [disabled]="subRequestMap?.get(element.id)?.status !== DataExchangeRequestStatusDto.Submitted"
        [title]="'dataManagement.dataExchangeRequests.actions.reopenSubRequest' | transloco"
        (click)="reopenSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>replay</mat-icon>
      </button>
      <button mat-icon-button type="button" [disabled]="subRequestMap?.get(element.id)?.status === DataExchangeRequestStatusDto.Deleted"
        [title]="'dataManagement.dataExchangeRequests.actions.withdrawSubRequest' | transloco"
        (click)="withdrawSubRequest.emit(element.id); $event.stopPropagation()">
        <mat-icon>undo</mat-icon>
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"
    [ngClass]="isItemSelected(row) ? 'background-highlight' : ''">
  </tr>

  <app-filter-menu #filterComponent="columnFilterComponent" [dataSource]="dataSource"></app-filter-menu>
</table>

<div class="loading-overlay" *ngIf="isLoading | async">
    <mat-spinner diameter="48" color="accent"></mat-spinner>
</div>

<mat-paginator *ngIf="isPaginatorVisible" [length]="1"
            [pageSize]="10"
            [pageSizeOptions]="[5, 10, 25, 100]"
            aria-label="Select page"
            (page)="onPageChanged($event)">
</mat-paginator>
